<!-- COMPRA - Lote aberto para compra -->
<div
  class="card-bid orange"
  *ngIf="animal_obj.type === 'SHOPPING' && animal_obj.status !== 'VENDIDO'"
>
  <div class="left">
    <h4>Valor de Compra</h4>
    <h1>{{ animal_obj.bid | currency : 'BRL' }}</h1>
    <h4 *ngIf="qtd_left > 0">{{ qtd_left }} Coberturas restantes</h4>
    <h4 *ngIf="qtd_left === 0">Todas as coberturas foram vendidas.</h4>
  </div>

  <div class="right" *ngIf="qtd_left > 0">
    <!-- Tipo Shopping  -->
    <button mat-button class="c_white" (click)="openPopupBuyShopping()">
      Comprar
    </button>
  </div>
</div>

<!-- COMPRA - Lance vendido -->
<div class="card-bid green center" *ngIf="animal_obj.status === 'VENDIDO'">
  <div class="left">
    <h4>Vendido</h4>
    <h1>{{ animal_bid | currency : 'BRL' }}</h1>
  </div>
</div>
